import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ExternalServiceSliceState {
  helpcrunchLoaded: boolean;
}

const initialState: ExternalServiceSliceState = {
  helpcrunchLoaded: false,
};

const externalServiceSlice = createSlice({
  name: 'externalService',
  initialState,
  reducers: {
    setHelpcrunchLoaded: (state, action: PayloadAction<boolean>) => ({
      ...state,
      helpcrunchLoaded: action.payload,
    }),
  },
});

export { externalServiceSlice };
